export default "__VITE_ASSET__O0n62iv3__"